import type { Identity } from '../types/auth';

/** Permission node (tesseract-auth) that unlocks the Data Controller export. */
export const DATA_CONTROLLER_PERMISSION = 'argus.datacontroller';

/**
 * Data Controller access (Staff Manager → Data Controller): the `argus.datacontroller` node, with
 * the same `SPY_Super_admin` override every other panel module has. The backend enforces the same
 * rule (`data_controller` in argus-backend src/auth.ts) on every request.
 */
export const canAccessDataController = (identity: Identity | null, isDev: boolean): boolean => {
  if (isDev) return true;
  if (!identity) return false;
  const groups: string[] = identity.raw?.custom?.groups || [];
  const permissions: string[] = identity.raw?.custom?.permissions || [];
  return groups.includes('SPY_Super_admin') || permissions.includes(DATA_CONTROLLER_PERMISSION);
};
